import { network } from 'services/network';

export const importToOpcXerFile = (params) => {
    return network.post('api/bo/importToOpcXerFile', params).then((response) => {
        return response.data;
    });
};
